import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/quick',
    name: 'quick',
    component: () => import( /* webpackChunkName: "index" */ '../views/quick.vue')
  },
  {
    path: '/release',
    name: 'release',
    component: () => import( /*发布说明列表*/ '../views/release.vue')
  },
  {
    path: '/releaseArticle',
    name: 'releaseArticle',
    component: () => import( /*发布说明文章*/ '../views/releaseArticle.vue')
  },
  {
    path: '/ArticleList',
    name: 'ArticleList',
    component: () => import( /*目录树页面*/ '../views/ArticleList.vue')
  },
  {
    path: '/JiSu',
    name: 'JiSu',
    component: () => import( /*极速智能配置页面*/ '../views/JiSu.vue')
  },
  {
    path: '/smartArticleList',
    name: 'SmartArticleList',
    component: () => import( /*目录树页面*/ '../views/SmartArticleList.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: '/help/',
  routes
})

export default router